module.exports = __webpack_public_path__ + "bac66272e5dc99187f6effc8dd355b56.pdf";